// 90 Minuti Home — minimal JS: testimonials prev/next scroller, the
// first-visit language modal, and the custom-uniforms photo carousel.
// Everything else on Home (category hover, product/league grids) is pure
// CSS, matching the React source (no JS carousel there).

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-m90-testimonial-prev], [data-m90-testimonial-next]');
  if (!button) return;

  const section = button.closest('.m90');
  const scroller = section && section.querySelector('[data-m90-testimonial-scroller]');
  if (!scroller) return;

  const card = scroller.querySelector('.m90-testimonial-card');
  const amount = (card ? card.offsetWidth : 320) + 16;
  const direction = button.hasAttribute('data-m90-testimonial-next') ? 1 : -1;
  scroller.scrollBy({ left: amount * direction, behavior: 'smooth' });
});

// ---------------------------------------------------------------- Language modal
// Matches src/components/LanguageModal.tsx: shown once on first visit,
// gated by localStorage (mirrors the React `hasSeenLanguageModal` flag).
// Choosing a language submits Shopify's native `localization` form — the
// same mechanism the header's own ES/EN selector uses — so there is only
// ever one source of truth for the storefront locale.
(function initLanguageModal() {
  const STORAGE_KEY = '90minuti:language-modal-seen';

  function markSeen() {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      // localStorage unavailable (private mode, etc.) — fail silently,
      // same behavior as the React useLocalStorage hook.
    }
  }

  function hasSeen() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('M90LanguageModal');
    if (!modal || typeof modal.showModal !== 'function') return;
    if (hasSeen()) return;
    modal.showModal();
  });

  document.addEventListener('click', (event) => {
    const closeBtn = event.target.closest('[data-m90-lang-close]');
    if (closeBtn) {
      const modal = closeBtn.closest('.m90-lang-modal');
      if (modal) modal.close();
      return;
    }
    // Clicking the ::backdrop area lands directly on the <dialog> element
    // itself (not a descendant), matching the React version's
    // onClick={dismissLanguageModal} on the backdrop.
    if (event.target && event.target.id === 'M90LanguageModal') {
      event.target.close();
    }
  });

  // Closing without choosing keeps the default language (Spanish),
  // matching the React modal's documented behavior.
  document.addEventListener('close', (event) => {
    if (event.target && event.target.id === 'M90LanguageModal') {
      markSeen();
    }
  }, true);

  // Choosing a language submits the localization form (full page reload),
  // so mark as seen synchronously before the browser navigates away.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.m90-lang-form');
    if (form) markSeen();
  });
})();

// ------------------------------------------------------- Custom uniforms carousel
// Matches src/components/PhotoCarousel.tsx: auto-rotate every 5s, pause on
// hover/focus, prev/next buttons, dots — crossfade via CSS opacity.
(function initPhotoCarousels() {
  const AUTO_ROTATE_MS = 5000;

  function setup(root) {
    const slides = Array.from(root.querySelectorAll('.m90-photo-carousel-slide'));
    const dots = Array.from(root.querySelectorAll('[data-m90-carousel-dot]'));
    if (slides.length <= 1) return;

    let index = 0;
    let paused = false;
    let timer = null;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function render() {
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    function goTo(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      render();
    }

    function start() {
      if (paused || reducedMotion || timer) return;
      timer = window.setInterval(() => goTo(index + 1), AUTO_ROTATE_MS);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin', () => { paused = true; stop(); });
    root.addEventListener('focusout', () => { paused = false; start(); });

    const prevBtn = root.querySelector('[data-m90-carousel-prev]');
    const nextBtn = root.querySelector('[data-m90-carousel-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(index - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    start();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-m90-photo-carousel]').forEach(setup);
  });
})();
